import React, { Component } from 'react'
import { Form, Card, Button, Select } from 'antd'
import PropTypes from 'prop-types'
import { concat } from 'lodash'
import styles from './index.module.scss'
const Option = Select.Option

class AddressForm extends Component {
  static propTypes = {
    form: PropTypes.object,
    adressList: PropTypes.array,
    obj: PropTypes.object,
    handleGetOption: PropTypes.func,
    handleGetAddaress: PropTypes.func
  }

  handleGetOption = (e) => {
    this.props.handleGetOption(e)
  }

  handleGetAddaress =(obj) => {
    this.props.handleGetAddaress(obj)
  }

  render () {
    const { getFieldDecorator } = this.props.form
    const { adressList = [], obj = {} } = this.props
    const formItemLayout = {
      labelCol: { span: 4 },
      wrapperCol: { span: 20 }
    }

    return (
      <Card title='地址信息' headStyle={{ padding: '0px', borderBottom: 'none' }} bodyStyle={{ padding: '0px' }} bordered={false}>
        <Form className={styles.adressInfo}>
          <Form.Item className={styles.formSelect} label='收货地址' {...formItemLayout}>
            {
              getFieldDecorator('username', {
                initialValue: obj.id,
                rules: [
                  { required: true, message: '请选择收货地址!' }
                ]
              })(
                  <Select onChange={(e) => { this.handleGetOption(e) }} size='small' style={{ minWidth: '350px' }}>
                  {
                    adressList.map((item, i) => (
                      <Option key={i} value={item.id} >{concat(item.addressRegion, item.address, ' ', item.receiver, ' ', item.phoneNumber)}</Option>
                    ))
                  }
                </Select>
              )
            }
          </Form.Item>

          <Form.Item style={{ marginLeft: '10px' }}>
           {
             JSON.stringify(obj) !== '{}'
               ? <Button style={{ marginRight: '9px' }} size='small' type='primary' onClick={() => { this.handleGetAddaress(2) }}>修改收货地址</Button>
               : null
           }

            <Button size='small' type='primary' onClick={() => { this.handleGetAddaress(1) }}>新增收货地址</Button>
          </Form.Item>
        </Form>
      </Card>
    )
  }
}
const Address = Form.create()(AddressForm)
export default Address
